import React, { useState, useEffect } from "react";
import Table from "react-bootstrap/Table";
import { NavLink, useHistory } from "react-router-dom";
import moment from "moment";
import LeftSideNavigation from "../../../vendorDashboardComponents/navigationSection/LeftSideNavigation";
import HomeReusableTopBarNavigation from "../../superAdminReusable/superAdminHomeButton/HomeReusableTopBarNavigation";
import { SuperAdminFilter } from "../../superAdminReusable/reusableTable/SuperAdminTopTextSearchIcon";
import { SuperAdminRestaurantTableBody } from "./tableSection/SuperAdminRestaurantTableBody";
import ViewOfferDetailsOffline from "../superAdminOffers/ViewOfferDetailsOffline";
import ViewOfferDetailsOnline from "../superAdminOffers/ViewOfferDetailsOnline";
import {
  getAllAdminRestaurantOffers,
  getRestaurantOfferDetailFromOfferID,
  editRestaurantMainCarousel,
} from "../../../../store/actions/SuperAdminActions/adminManageOffers";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { SmallLoader } from "../../../Loader/SmallLoader";
import BasicPagination from "./../../../Pagination/Pagination";
import { OffersFilterSection } from "./OffersFilterSection";
import { SortComponent } from "../../../reusableComponents/SortAndFilterComponent/SortComponent";
import CSVDownloader from "../../../reusableComponents/csvDownload/csvDownload";
//
const SuperAdminRestaurantOffers = (props) => {
  const history = useHistory();
  const [page, setPage] = useState(1);
  const [start, setStart] = useState(0);
  const [end, setEnd] = useState(10);
  const handleBatchChange = (pageNo) => {
    window.scrollTo(0, 0);
    var calcStart = pageNo * 10 - 10;
    setStart(calcStart);
    setEnd(pageNo * 10);
    setPage(pageNo);
  };

  const [loading, setLoading] = useState(false);
  const [showView, setShowView] = useState(false);
  const [showView2, setShowView2] = useState(false);

  const [dataOnline, setDataOnline] = useState();
  const [dataOffline, setDataOffline] = useState();
  const handleShowView = (offer) => {
    setDataOnline(offer);
    setShowView(true);
  };
  const handleShowView2 = (offer) => {
    setDataOffline(offer);
    setShowView2(true);
  };
  const handleCloseView = () => setShowView(false);
  const handleCloseView2 = () => setShowView2(false);

  const onSuccessGetResOffers = () => {
    setLoading(false);
  };

  const onErrorGetResOffers = () => {
    setLoading(false);
  };

  ///////// Edit Action
  const handleEditShowAction = (offer) => {
    history.push({
      pathname: `/superadminoffers/edit-online-offer/${offer._id}`,
      state: { actionBy: "EditAdmin", editData: offer },
    });
  };

  const handleEditShow2Action = (offer) => {
    history.push({
      pathname: `/superadminoffers/edit-offline-offer/${offer._id}`,
      state: { actionBy: "EditAdmin", editData: offer },
    });
  };

  const [search, setSearch] = useState("");
  const [offerType, setOfferType] = useState("All");
  const [status, setStatus] = useState("All");
  const [isonline, setisonline] = useState("All");
  const [showFilter, setShowFilter] = useState(false);
  const handleShowFilter = () => {
    setShowFilter(true);
  };
  const searchClick = () => {
    setisonline(offerType);
    setShowFilter(false);
  };
  const cancelClick = () => {
    setShowFilter(false);
    setStatus("All");
    setOfferType("All");
  };

  const [state, setState] = useState({
    anchorEl: null,
  });

  const [sortBy, setSortBy] = useState("");
  const handleClick = (event) => {
    setState({
      ...state,
      anchorEl: event.currentTarget,
    });
  };
  const handleClose = () => {
    setState({
      ...state,
      anchorEl: null,
    });
  };
  const handleSelect = (value) => (e) => {
    setSortBy(value);
    handleClose();
  };

  const filteredData = props.allRestaurantAdminOffers;
  let filterOffers = [];

  if (isonline === "All") {
    filterOffers = filteredData;
  } else if (isonline === "Online") {
    filterOffers = filteredData.filter((offer) => {
      if (offer.isOnline) {
        return offer;
      } else {
        return false;
      }
    });
  } else if (isonline === "Offline") {
    filterOffers = filteredData.filter((offer) => {
      if (!offer.isOnline) {
        return offer;
      } else {
        return false;
      }
    });
  }
  if (sortBy === "A-Z") {
    filterOffers = filteredData.sort((a, b) => {
      if (a.name < b.name) return -1;
      if (a.name > b.name) return 1;
      return 0;
    });
  } else if (sortBy === "Z-A") {
    filterOffers = filteredData.sort((a, b) => {
      if (a.name < b.name) return 1;
      if (a.name > b.name) return -1;
      return 0;
    });
  }
  if (search) {
    let searchData = new RegExp(search, "i");
    filterOffers = filteredData.filter((getall) => {
      if (searchData.test(getall.name)) {
        return getall;
      } else if (searchData.test(getall.coupon_code)) {
        return getall;
      } else {
        return false;
      }
    });
  }

  // filterOffers = filteredData.filter((offer) => {
  //   return (
  //     offer?.name.toLowerCase().includes(search.toLowerCase()) ||
  //     offer?.coupon_code.toLowerCase().includes(search.toLowerCase())
  //   );
  // });

  useEffect(() => {
    const token = props.auth.user.accessToken;
    setLoading(true);
    props.getAllAdminRestaurantOffers(
      token,
      moment().subtract(30, "days").format("YYYY-MM-DD"),
      moment().format("YYYY-MM-DD"),
      onSuccessGetResOffers,
      onErrorGetResOffers
    );
  }, []);

  const onSuccessEdit = () => {
    setLoading(false);
  };
  const onErrorEdit = () => {
    setLoading(false);
  };
  const onChangeToogleStatus = (status, offerId, toogleName) => {
    const token = props.auth.user.accessToken;
    var changeCarouselStatus = {};
    if (toogleName === "carousel") {
      changeCarouselStatus.send_to_carousel = !status;
    } else if (toogleName === "primary") {
      changeCarouselStatus.mark_as_primary = !status;
    } else if (toogleName === "status") {
      changeCarouselStatus.active = !status;
    }

    props.editRestaurantMainCarousel(
      token,
      offerId,
      changeCarouselStatus,
      onSuccessEdit,
      onErrorEdit
    );
  };
  const downloadData = {
    headers: [
      { label: "Business Name", key: "name" },
      { label: "My Offers \n Offer Type \n Offer Id", key: "offeridtype" },
      { label: "Start- \n end Date", key: "date" },
      { label: " Discount Type", key: "discounttype" },
      { label: "Discount", key: "discount" },
      { label: "Fixed Amount", key: "fixedamount" },
      { label: "Status", key: "status" },
    ],
    data: filterOffers
      ? filterOffers?.map((ele) => {
          return {
            name: ele?.restaurant_id?.restaurant_name,
            offeridtype: `${ele?.name} \n ${ele?._id}`,
            date: `${moment(ele?.offer?.start_date).format(
              "Do MMM YY"
            )} \n ${moment(ele?.offer?.end_date).format("Do MMM YY")}`,
            discounttype: ele?.offer?.isOnline
              ? ele?.offer?.isPercentage
                ? "Percentage"
                : "Fixed Amount"
              : "_",
            discount: ele?.offer?.isOnline
              ? ele?.offer?.isPercentage
                ? ele?.discount
                : "-"
              : "-",
            fixedamount: ele?.offer?.isOnline
              ? !ele?.offer?.isPercentage
                ? ele?.offer?.discount
                : "-"
              : "-",
            status: ele?.offer?.active ? "Active" : "Inactive",
          };
        })
      : [],
  };

  return (
    <React.Fragment>
      <div className="container-fluid">
        <div className="row">
          <div className="left-side-panel">
            <LeftSideNavigation displayLink={1} />
          </div>
          <div className="super-admin-right-side-panel">
            <HomeReusableTopBarNavigation />
            <div className="super-admin-inside-right-side-panel">
              <div className="d-flex justify-content-between align-items-center pt-4 pb-3">
                <div className="f24_700_HelveticaNeue">
                  Vendor Offer Management
                </div>
                <NavLink
                  to="/superadminoffers/add-vendor-offer"
                  className="btn btn-danger btn2 btn-lg"
                >
                  + Add Offer
                </NavLink>
              </div>
              {/* <SuperAdminFilter
                onChange={(e) => setSearch(e.target.value)}
                offerType={offerType}
                status={status}
                showFilter={showFilter}
                sortBy={sortBy}
                handleChangeCode={(e) => setSortBy(e.target.value)}
                handleShowFilter={handleShowFilter}
                handleOfferTypeChange={(e) => setOfferType(e.target.value)}
                handleStatusChange={(e) => setStatus(e.target.value)}
                searchClick={searchClick}
                cancelClick={cancelClick}
              /> */}
          
               <div className="col-sm-2 col-md-3 col-lg-10">
                {/* <div className="col-3"> */}
              <OffersFilterSection
              //className="d-flex justify-content-between align-items-center"
                offerType={offerType}
                status={status}
                showFilter={showFilter}
                handleShowFilter={handleShowFilter}
                handleOfferTypeChange={(e) => setOfferType(e.target.value)}
                handleStatusChange={(e) => setStatus(e.target.value)}
                searchClick={searchClick}
                cancelClick={cancelClick}
                onChange={(e) => setSearch(e.target.value)}
                search={state.search}
                
                sortMenuButton={
                  <SortComponent
                
                    handleClick={handleClick}
                    anchorEl={state.anchorEl}
                    handleClose={handleClose}
                    selectClick={(data) => handleSelect(data)}
                  />
                }
                downButton={
                  <CSVDownloader
                    filename={"Offers-Summary-Report"}
                    headers={downloadData.headers}
                    data={downloadData.data}
                  />
                }
              />
              </div>

              <div className="user-table-reusable-superadmin table-responsive">
                <Table className="w-100 enMinWidth900">
                  <thead>
                    <tr className="super_admin_all_users_table_head">
                      <th style={{ width: "11%" }} className="f10-500">
                        Business
                        <br />
                        Name/ID
                      </th>
                      <th style={{ width: "18%" }} className="f10-500">
                        My Offers/Offer Type/
                        <br />
                        Offer ID
                      </th>
                      <th style={{ width: "8%" }} className="f10-500">
                        Start -<br />
                        End Date
                      </th>
                      <th style={{ width: "10%" }} className="f10-500">
                        Discount
                        <br />
                        Type
                      </th>
                      <th style={{ width: "10%" }} className="f10-500">
                        Discount
                      </th>
                      <th style={{ width: "10%" }} className="f10-500">
                        Fixed
                        <br />
                        Amount
                      </th>
                      <th style={{ width: "10%" }} className="f10-500">
                        Main
                        <br />
                        Carousel
                      </th>
                      <th style={{ width: "10%" }} className="f10-500">
                        Status
                      </th>
                      <th style={{ width: "10%" }} className="f10-500">
                        Primary
                      </th>
                    </tr>
                  </thead>
                  {props.auth.secondary_loader ? (
                    <SmallLoader />
                  ) : (
                    filterOffers &&
                    filterOffers
                      .slice(start, end)
                      .map((offer, index) => (
                        <SuperAdminRestaurantTableBody
                          handleShowView={handleShowView}
                          handleShowView2={handleShowView2}
                          handleEditShow={handleEditShowAction}
                          handleEditShow2={handleEditShow2Action}
                          onChangeToogleStatus={(status, offerId, toogleName) =>
                            onChangeToogleStatus(status, offerId, toogleName)
                          }
                          offer={offer}
                          keys={index}
                        />
                      ))
                  )}
                </Table>
              </div>

              <BasicPagination
                totalRecords={filterOffers.length}
                limit={10}
                batch={page}
                onBatchChange={(e) => handleBatchChange(e)}
              />
            </div>
          </div>
        </div>
      </div>
      <ViewOfferDetailsOnline
        onClickCloseView={handleCloseView}
        onClickshowView={showView}
        restaurantDetailFromOfferId={dataOnline}
        actionBy={"viewSuperAdmin"}
      />
      <ViewOfferDetailsOffline
        onClickCloseView={handleCloseView2}
        onClickshowView={showView2}
        restaurantDetailFromOfferId={dataOffline}
        actionBy={"viewSuperAdmin"}
      />
    </React.Fragment>
  );
};

SuperAdminRestaurantOffers.propTypes = {
  auth: PropTypes.object.isRequired,
  getAllAdminRestaurantOffers: PropTypes.func.isRequired,
  getRestaurantOfferDetailFromOfferID: PropTypes.func.isRequired,
  editRestaurantMainCarousel: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  allRestaurantAdminOffers: state.superAdminOffers.allRestaurantAdminOffers,
});

export default connect(mapStateToProps, {
  getAllAdminRestaurantOffers,
  getRestaurantOfferDetailFromOfferID,
  editRestaurantMainCarousel,
})(SuperAdminRestaurantOffers);
